'use strict';

import { addClassToElement } from '@jspartials/class-list-utils';

const prepend = ($parent, $newChild) => {
  $parent.insertBefore($newChild, $parent.firstChild);
};

const insertSiblingBefore = ($elem, $newSibling) => {
  $elem.parentNode.insertBefore($newSibling, $elem);
};

const insertSiblingAfter = ($elem, $newSibling) => {
  $elem.parentNode.insertBefore($newSibling, $elem.nextSibling);
};

const appendElementContent = ($elem, content) => {
  if (typeof content === 'string') {
    if (content) {
      $elem.innerHTML = content;
    }
  } else {
    $elem.appendChild(content);
  }
};

const setAttributes = ($elem, attributes) => {
  attributes.forEach((attr) => {
    $elem.setAttribute(attr.name, attr.value);
  });
};

const createElement = ({
  tag,
  content = '',
  classes = [],
  attributes = []
}) => {
  if (!tag) {
    return null;
  }

  const $newElement = document.createElement(tag);

  classes.forEach((singleClass) => {
    addClassToElement($newElement, singleClass);
  });

  appendElementContent($newElement, content);

  setAttributes($newElement, attributes);

  return $newElement;
};

const serializeForm = ($form) => {
  return new URLSearchParams(new FormData($form)).toString();
};

const multipleEventsListeners = (elem, events, func) => {
  events.split(' ').forEach((e) => elem.addEventListener(e, func, true));
};

const listenDOMEvent = ($elem, eventName = '', callback = null) => {
  if ($elem && eventName && callback) {
    $elem.addEventListener(eventName, callback);
  }
};

const dispatchCustomEvent = (eventName = '', detail = {}) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};

/**
 * Delegated event listener: callback fires with `this` set to the closest
 * descendant of rootElement matching selector, like jQuery's `.on(event, selector, cb)`
 * @param {Element} rootElement - The element to attach the listener to
 * @param {string} eventType - The event type to listen for
 * @param {string} selector - The selector dynamic descendants must match
 * @param {function} callback - Called with `this` bound to the matched element
 * @param {boolean|object} options - Passed through to addEventListener
 * @returns {void}
 */
const addDynamicEventListener = (
  rootElement,
  eventType,
  selector,
  callback,
  options
) => {
  rootElement.addEventListener(
    eventType,
    (event) => {
      const target = event.target.closest(selector);
      if (target && rootElement.contains(target)) {
        callback.call(target, event);
      }
    },
    options
  );
};

export {
  prepend,
  createElement,
  insertSiblingBefore,
  insertSiblingAfter,
  serializeForm,
  setAttributes,
  appendElementContent,
  multipleEventsListeners,
  listenDOMEvent,
  dispatchCustomEvent,
  addDynamicEventListener
};
